import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getDonationCurrencies } from 'lib/supabaseQueries';
import { useAuthContext } from 'context/authContext';

const useCurrenciesOptions = () => {
  const { organization, isInitialized } = useAuthContext();

  const { data, isLoading } = useQuery({
    queryKey: ['donationCurrencies', organization?.id],
    queryFn: () => getDonationCurrencies(organization.id),
    enabled: isInitialized && !!organization?.id
  });

  const currenciesOptions = useMemo(() => {
    if (data?.data) {
      return data.data.map(({ currency_id, currency }) => ({
        label:
          currency.currency_name +
          (currency.symbol ? ` (${currency.symbol})` : ''),
        value: currency_id
      }));
    }
    return [];
  }, [data]);

  return { currenciesOptions, loading: isLoading };
};

export default useCurrenciesOptions;
